import type { FaireProductEntity } from "../../entity_types/product";

export const p_xj9nckmwz5: FaireProductEntity = {
  token: "p_xj9nckmwz5",
  type: "product",
  name: "Sea Salt Grapefruit Petite Candle",
  brandToken: "b_345v3zg1",
  brandName: "Apotheke",
  imageUrl: "https://cdn.faire.com/fastly/ad4a7a4d0a281b95f529140a64130aba0fe1a194549f8d45c95c640f3dc1ed9e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5fe71672739a6488dc07f9a7de7c186fed13d2cf03488032bd76a5d1e3e4548a.jpeg",
    "https://cdn.faire.com/fastly/c068ff89f9bdbaa9da999759233b6e2897c4319ef0e5a332c3c30ce750d6a9bc.jpeg"
  ],
  priceDollars: 12.5,
  description: "The Fragrance\nSea Salt Grapefruit balances tangy sea salt, black pepper, and ripe grapefruit with sweet tarragon and a fresh dewdrop accord for a bright and citrusy fragrance.\n\nThe Product\nMade with a premium soy wax blend and essential and perfume-grade fragrance oils, this luxury scented candle is designed to provide a clean-burning and exceptional scent experience.\n\nThe Vessel\nThis blush orange specialty glass has a delicate translucent charm, with a frosted interior that gently diffuses the candle's glow.\n\nThe Details\n\nNet Weight: 5 oz. (141 g)\nApproximate Burn Time: 20-25 hours\nCandle Dimensions: 2.5\" DIA x 3.25\" H\nFragrance Family: Citrus\nTop Notes: Grapefruit, Lemon, Tropical Fruits, Green Fruits, Mint\nMiddle Notes: Green Florals, Watery Nuances, Peach, Red Berry\nBottom Notes: Musk, Coconut, Amber\n\nMade in the USA\n\nFor more information about our products, visit Ingredients.",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:57.002Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
